import React, { Fragment } from "react";
import { Card, Col } from 'react-bootstrap';
import '../../../../styles/diario.scss'

const Divida = (props) => {

    return (
        <Fragment>
            <Col>
                <Card className="card-list">
                <Card.Header><h5>{props.divida.nome} / {props.divida.cnpj}</h5></Card.Header>
                    <Card.Body>
                        <p>Valor: {props.divida.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 })}</p>
                    </Card.Body>
                    <hr />
                </Card>
            </Col>
        </Fragment >)
}

export default Divida;